/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import HTMLViewer from '../../components/HTMLViewer';
import { dataService } from '../../services/data.service';
import { isValidDeltaOps, quillGetHTMLWithBlot, replaceMergeFieldsInHtml } from '../../helpers/CommonFunctions';
import ApplicationContext from '../../context/ApplicationContext';
import moment from 'moment';

export default function HandleUI({component, show, setShow, selectedLanguage, setDataDocumentPercent, formData, pages, setPages, droppedComponents, setDroppedComponents, components, setComponenents, componentIndex, checkVisibility, componentAnswers, setComponentAnswers}) {
    const [tempComponent, setTempComponent] = useState(component);
    const [componentsLoading, setComponenentsLoading] = useState('');
    let [templateComponents, setTemplateComponents] = useState([]);
    const [timer, setTimer] = useState(null);
        
    const [mobileTextHtml, setMobileTextHtml] = useState('Lorem Ipsum')
    const [paragraphTextHtml, setParagraphTextHtml] = useState('Lorem Ipsum')
    const { mergeFieldValues } = useContext(ApplicationContext);
    
    useEffect(() => {
        if (!isValidDeltaOps(component.mobile_text)) {
            console.warn("Delta is empty or default. Skipping mobile text generation.");
            return;
        }
        if (component.mobile_text && typeof component.mobile_text === "object") {
            const html = quillGetHTMLWithBlot(component.mobile_text)
            const finalHTML = replaceMergeFieldsInHtml(html, mergeFieldValues)
            setMobileTextHtml(finalHTML)
        } else if (component.mobile_text && typeof component.mobile_text === "string") {
            setMobileTextHtml(component.mobile_text)
        }
    }, [component.mobile_text])

    useEffect(() => {
        if (!isValidDeltaOps(component.properties.textContent)) {
            console.warn("Delta is empty or default. Skipping mobile view paragraph generation.");
            return;
        }
        if (component.properties.textContent && typeof component.properties.textContent === "object") {
            const html = quillGetHTMLWithBlot(component.properties.textContent)
            const finalHTML = replaceMergeFieldsInHtml(html, mergeFieldValues)
            setParagraphTextHtml(finalHTML)
        } else if (component.properties.textContent && typeof component.properties.textContent === "string") {
            setParagraphTextHtml(component.properties.textContent)
        }
    }, [component.properties.textContent])

    useEffect(() => {
        if (component.component_type === 'input' && component?.properties?.inputType === "merge field" && !component.value) {
            const merge_field_value = component?.merge_fields?.map(field => {
                const rawValue = mergeFieldValues[field._id]; // Get raw value from mergeFieldValues
                let value;
        
                if (field._id?.toLowerCase().includes('date')) {
                    // Check if the raw date ends with "T00:00:00.000Z"
                    const isMidnightUTC = rawValue?.endsWith('T00:00:00.000Z');
                    value = rawValue
                        ? isMidnightUTC
                            ? rawValue.split('T')[0].split('-').reverse().join('-') // Format as MM-DD-YYYY
                            : moment(rawValue).format('MM-DD-YYYY hh:mm:ss') // Default date-time format
                        : '';
                } else if (field._id?.toLowerCase().includes('time')) {
                    value = rawValue ? moment(rawValue).format('h:mm:ss') : ''; // Time formatting
                } else {
                    value = rawValue; // Default to the raw value for other cases
                }
        
                return value;
            }).join(" ");
        
            handleInputChange(merge_field_value, component);
        }        
    }, [])
        
    const MobileTextUI = (component) => {
        return(
            <div className={`font-normal text-[#333] mb-4`} style={{fontSize: component?.mobile_text_font_size}}>
                <p 
                    id={component.component_id} 
                    dangerouslySetInnerHTML={{__html: mobileTextHtml}}
                    className={`cursor-default outline-none min-w-[50px] overflow-hidden facility-profile break-words`} 
                />
            </div>
        )
    }

    useEffect(() => {
        if(component.type === 'template') {
            setComponenentsLoading(component.component_id);
            dataService.GetTemplateComponents(component.template_id, component.template_version_id, component.component_id, 'mobile', formData.form_id, formData.version_id).then((res) => {
                if(res.error === false) {
                    setTemplateComponents(res.data.data);
                    setComponenentsLoading('');
                }
            })
        }
    }, [])

    const debouncedHandleInputChange = async(value, chosenComponent) => {
        // Create a copy of the component with the updated key-value pair
        let payload = {
            "value": value.trim(),
        }
        dataService.UpdateDocumentComponent(payload, formData.form_id, formData.version_id, chosenComponent.component_id).then((res) => {
            setDataDocumentPercent((prev) => ({
                ...prev,
                completed_components_count: res.data.completed_components_count,
                incomplete_required_fields: res.data.incomplete_required_fields
            }))
        });
    };

    async function handleCheckboxClick(value, chosenComponent, componentIndex) {
        const index = chosenComponent.values.indexOf(value);
        if (index === -1) {
            chosenComponent.values.push(value);
        } else {
            chosenComponent.values.splice(index, 1);
        }
        checkVisibility(components);
        if(tempComponent.type === 'template') {
            let comp = templateComponents.filter((item) => item.component_id === chosenComponent.component_id);
            comp[0]['values'] = chosenComponent.values;
            templateComponents[componentIndex] = comp[0];
            setTemplateComponents([...templateComponents]);
        } else {
            setTempComponent((prev) => ({
                ...prev,
                value: chosenComponent.values
            }));
            components[componentIndex] = chosenComponent
            setComponenents([...components])
            setComponentAnswers((prev) => ({
                ...prev,
                [chosenComponent.component_id]: chosenComponent.values
            }))
            // setTimeout(() => {
            //     if(pages[chosenComponent.page]) {
            //         const index = (pages[chosenComponent.page].components).findIndex(obj => obj.component_id === chosenComponent.component_id);
            //         pages[chosenComponent.page].components[index]['values'] = chosenComponent.values;
            //         setPages([...pages]);
            //         droppedComponents[chosenComponent.page] = pages[chosenComponent.page];
            //         setDroppedComponents([...droppedComponents])
            //     }
            // }, [2500])
        }
        let payload = {
            "values": chosenComponent.values
        }
        dataService.UpdateDocumentComponent(payload, formData.form_id, formData.version_id, chosenComponent.component_id).then((res) => {
            setDataDocumentPercent((prev) => ({
                ...prev,
                completed_components_count: res.data.completed_components_count,
                incomplete_required_fields: res.data.incomplete_required_fields
            }))
        });
    }

    const handleInputChange = (value, chosenComponent, selected_label) => {
        if(component.type === 'template') {
            let comp = templateComponents.filter((item) => item.component_id === chosenComponent.component_id);
            comp[0]['value'] = value.trim();
            templateComponents[componentIndex] = comp[0];
            setTemplateComponents([...templateComponents]);
        } else {
            setTempComponent((prev) => ({
                ...prev,
                value: value
            }));
            components[componentIndex]['value'] = value;
            components[componentIndex]['selected_label'] = selected_label || '';
            setComponenents([...components]);
            setComponentAnswers((prev) => ({
                ...prev,
                [chosenComponent.component_id]: value
            }))
            // setTimeout(() => {
            //     if(pages[chosenComponent.page]) {
            //         const index = (pages[chosenComponent.page].components).findIndex(obj => obj.component_id === chosenComponent.component_id);
            //         pages[chosenComponent.page].components[index]['value'] = value;
            //         pages[chosenComponent.page].components[index]['selected_label'] = selected_label || '';
            //         setPages([...pages]);
            //         droppedComponents[chosenComponent.page] = pages[chosenComponent.page];
            //         setDroppedComponents([...droppedComponents])
            //     }
            // },[2500])
        }
        if(chosenComponent.type === 'radio' || chosenComponent.type === 'select-box') {
            checkVisibility(components);
        }
        setShow(false)
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            debouncedHandleInputChange(value, chosenComponent, componentIndex)
        }, 200);
        setTimer(newTimer);
    }

    const uiHandle = (temp, componentIndex) => {
        let ui = '';
        switch(temp.component_type) {
        case 'input': ui = (
            <div className="relative">
                {temp?.mobile_text && MobileTextUI(temp)}
                <div className="w-full flex flex-col">
                    <label htmlFor={temp?.component_id} className={`font-semibold text-sm flex items-center text-[#007EB4]`}>{temp?.label?.name}
                        {temp?.is_required && <span className={`${selectedLanguage === 'ar' ? 'mr-2' : 'ml-2 '}`}><img src="/images/form-required.svg" alt="required" /></span>}
                    </label>
                    <input 
                        value={temp.value} 
                        onChange={(e) => formData.acknowledged_answer === "Yes" ? '' : handleInputChange(e.target.value, temp, componentIndex)} 
                        data-testid={`${temp?.component_type}-${temp?.mobile_index}`}
                        autoComplete="off" type="text" id={temp?.component_id} 
                        readOnly={temp.properties.read_only}
                        disabled={formData.acknowledged_answer === "Yes"}
                        className={`mt-2 bg-[#F2F2F2] border placeholder:capitalize border-[#797979]
                        py-[10px]  px-[12px] rounded h-[40px] font-normal text-[#333] text-sm  outline-0  placeholder:text-sm placeholder:text-[#797979]`} 
                        placeholder={temp?.placeholder?.name} />
                </div>
            </div>
        )
            break;
        case 'radio': if(temp?.fields.length > 2 || temp.fields[0].label?.length > 20 || temp?.fields[1]?.label?.length > 20) {
            ui = <div className="relative">
                {temp?.mobile_text && MobileTextUI(temp)}
                <div className="w-full flex flex-col">
                    <label htmlFor={temp?.component_id} className={`font-semibold text-sm flex items-center text-[#007EB4] pb-4`}>{temp?.label?.name}
                        {temp?.is_required && <span className={`${selectedLanguage === 'ar' ? 'mr-2' : 'ml-2 '}`}><img src="/images/form-required.svg" alt="required" /></span>}
                    </label>
                    {temp?.fields.map((item, index) => (
                        <div key={`${temp.component_id}-${index}`} className={`relative custom-radioBlue ${formData.acknowledged_answer === "Yes" ? 'cursor-default pointer-events-none' : 'cursor-pointer'} flex items-center ${temp?.fields.length - 1 === index ? '' : 'mb-2'}`}>
                            <input onChange={(e) => formData.acknowledged_answer === "Yes" ? '' : handleInputChange(item.value, temp, componentIndex)} checked={temp.value === item.value} id={`${temp.component_id}-radio-${index}`} type="radio" name={`${temp.component_id}-radio-${index}`} />
                            <label data-testid={`${temp?.component_type}-${temp?.mobile_index}-${index}`} style={{overflowWrap: 'anywhere'}} htmlFor={`${temp.component_id}-radio-${index}`} className={`flex text-sm font-normal text-[#333] pl-[30px] relative ${formData.acknowledged_answer === "Yes" ? 'cursor-default' : 'cursor-pointer'} blood-group-label break-words`}>
                                {item.label}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        } else {
            ui = (
                <div>
                    {temp?.mobile_text && MobileTextUI(temp)
                    }
                    <p className={`text-[#007EB4] text-sm font-semibold ${selectedLanguage === 'ar' ? 'text-end' : 'text-justify'} `}>
                        {temp?.label?.name}</p>
                    <div className='flex justify-center items-center'>
                        {component.is_required && <img src="/images/form-required.svg" alt="required" className='mr-2 mt-2' />}
                        <div>
                            <div className={`flex mt-[12px] justify-center ${formData.acknowledged_answer === "Yes" ? 'pointer-events-none' : ''}`}>
                                <div onClick={() => handleInputChange(temp.fields[0].value, temp, componentIndex)} data-id={`${temp.component_type}_${temp.fields[0].label}`} data-testid={`${temp?.component_id}_${temp.fields[0].value.replaceAll(' ', '_')}`}
                                    className={`flex ${temp.value === temp.fields[0].value ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} justify-center gap-[12px] rounded-l-[47px] border border-[#333] items-center px-[30px] py-[8px] cursor-pointer`}>
                                    <p className={`font-normal ${temp.value === temp.fields[0].value ? ' text-[#F2F2F2]' : 'text-[#333333]'} text-sm`}>{temp.fields[0].label}</p>
                                </div>
                                <div onClick={() => handleInputChange(temp.fields[1].value, temp)} data-id={`${temp.component_type}_${temp.fields[1].label}`} data-testid={`${temp?.component_id}_${temp.fields[1].value.replaceAll(' ','_')}`} className={`flex ${temp.value === temp.fields[1].value ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} justify-center gap-[12px] rounded-r-[47px] 
                            border border-[#333] items-center px-[30px] py-[8px] cursor-pointer`}>
                                    <p className={`font-normal ${temp.value === temp.fields[1].value ? ' text-[#F2F2F2]' : 'text-[#333333]'} text-sm`}>{temp.fields[1].label}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
            break;
        case 'checkbox': ui = (
            <div className='relative' data-testid="CheckboxComponent">
                {temp?.mobile_text && MobileTextUI(temp)}
                <label htmlFor={temp?.component_id} className={`font-semibold text-sm flex items-center text-[#007EB4] mb-3`}>{temp?.label?.name}
                    {temp?.is_required && <span className={`${selectedLanguage === 'ar' ? 'mr-2' : 'ml-2 '}`}><img src="/images/form-required.svg" alt="required" /></span>}
                </label>
                {temp?.fields.map((item, index) => (
                    <div key={`${temp?.component_id}-${item.value}`} className={`flex items-center leading-none gap-2 ${formData.acknowledged_answer === "Yes" ? 'cursor-default pointer-events-none' : 'cursor-pointer'} custom-checkbox4 relative ${temp?.fields.length - 1 === index ? '' : 'mb-3'}`}>
                        <input
                            type="checkbox"
                            checked={temp.values.includes(item.value)}
                            id={`${temp?.component_id}-${item.value}`}
                            className='cursor-pointer'
                            onChange={() =>  formData.acknowledged_answer === "Yes" ? '' : handleCheckboxClick(item.value, temp, componentIndex)}
                            data-testid={`${temp?.component_id}-${item.value}`}/>
                        <label data-id={`Checkbox_${item.value}`} data-testid={`${temp?.component_type}-${temp?.mobile_index}-${index}`} className={`cursor-pointer text-sm text-[#333] ml-2 mt-0.5`} for={`${temp?.component_id}-${item.value}`}>{item?.label}</label>
                    </div>
                ))}
            </div>
        )
            break;
        case 'paragraph': ui = (
            <div className='relative' data-testid="ParagraphComponent">
                {temp?.mobile_text && MobileTextUI(temp)}
                <p 
                    data-testid="paragraph-text" className={`font-normal text-[#333] bg-transparent`} 
                    style={{fontSize: temp?.styles?.fontSize}}
                    dangerouslySetInnerHTML={{__html: paragraphTextHtml}}
                />
            </div>
        )
            break;
        case 'textarea': ui = (
            <div className="relative" data-testid="TextAreaComponent">
                {temp?.mobile_text && MobileTextUI(temp)
                }
                <div className="w-full flex flex-col">
                    <label htmlFor={temp?.component_id} className={`font-semibold text-sm flex items-center text-[#007EB4]`}>{temp?.label?.name}
                        {temp?.is_required && <span className={`${selectedLanguage === 'ar' ? 'mr-2' : 'ml-2 '}`}><img src="/images/form-required.svg" alt="required" /></span>}
                    </label>
                    <textarea
                        value={temp?.value}
                        onChange={(e) => formData.acknowledged_answer === "Yes" ? '' : handleInputChange(e.target.value, temp)}
                        data-testid={`${temp?.component_type}-${temp?.mobile_index}`}
                        data-id="TextareaComponentField"
                        rows={temp?.rows}
                        maxLength={temp?.properties?.maxLength || ''}
                        disabled={formData.acknowledged_answer === "Yes"}
                        className={`resize-none border border-[#797979] outline-0 bg-[#F2F2F2] py-[10px]  px-[12px] rounded font-normal row-lines mt-2 forms-authoring-textarea text-[#333] text-sm`}
                        id={temp?.id}
                        placeholder={temp?.placeholder?.name}
                    />
                </div>
            </div>
        )
            break;
        case 'select-box': ui = (
            <div className='relative' data-testid="SelectBoxComponent">
                {temp?.mobile_text && MobileTextUI(temp)}
                <div className="w-full">
                    <label htmlFor={temp?.component_id} className={`font-semibold text-sm flex items-center text-[#007EB4]`}>{temp?.label?.name}
                        {temp?.is_required && <span className={`${selectedLanguage === 'ar' ? 'mr-2' : 'ml-2 '}`}><img src="/images/form-required.svg" alt="required" /></span>}
                    </label>
                    <button
                        onClick={() => formData.acknowledged_answer === "Yes" ? '' : setShow(show === temp?.component_id ? '' : temp?.component_id) }
                        data-testid={`${temp?.component_type}-${temp?.mobile_index}`}
                        data-id={`SelectBoxButton`}
                        className={`border border-[#797979] rounded h-[40px] px-3 ${formData.acknowledged_answer === "Yes" ? 'pointer-events-none' : ''} py-4 flex justify-between items-center w-full font-normal text-sm mt-1  text-[#333333]
                        outline-0`}
                        type="button" aria-expanded="false">
                        {temp?.value || temp?.placeholder?.name}
                        <img loading="lazy" decoding="async"
                            src="/images/arrow-down.svg" alt="arrow" />
                    </button>
                    <ul id="#patient-dropdownMenuButton1" className={`rounded-[4px] bg-[#F2F2F2] dropdown-menu absolute m-0 shadow-black z-[9999] left-0 hidden  w-full p-2 ${show === temp?.component_id ? 'show' : ''}`}
                        aria-labelledby="patient-dropdownMenuButton1">
                        {temp.fields.map((item, index = 0) => (
                            <li key={index} className="automatic hover:bg-[#F2F4F5] rounded-lg p-2 cursor-pointer" onClick={(e) => handleInputChange(item.value, temp, componentIndex)}>
                                <p data-id={`${temp?.component_type}-${item?.value}`} data-testid={`${temp?.component_type}-${temp?.mobile_index}-${index}`} className="dropdown-item font-normal text-sm text-[#000]">
                                    {item.label}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={['filter-overlay cursor-pointer ', show === temp?.component_id ? 'filter-open ' : ''].join('')} onClick={() => setShow('')} />
            </div>
        )
            break;
        case 'template': ui = (
            <div className='relative'>
                {temp?.mobile_text && MobileTextUI(temp)
                }
                {componentsLoading === temp.component_id ?
                    <div className='animate-pulse w-full h-[20px] bg-slate-300' />
                    : templateComponents.length > 0 && templateComponents?.map((pComponent, index) => (
                        <div key={index} className={`mt-4 border-b border-[#D7D7D7] pb-6`}>
                            {uiHandle(pComponent, index)}
                        </div>
                    ))}
            </div>
        )
            break;
        }
        return ui;
    }
    
    return(
        uiHandle(tempComponent, componentIndex)
    )
}